/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_Peer_HintInputs */

const th_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังรออีกคนเริ่ม เปิดเสียงเพื่อฟังพวกเขา`)
};

const en_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for the other participant to start. Enable sound to hear them.`)
};

const ja_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手の開始を待っています。音声を有効にすると相手の声が聞こえます。`)
};

const zh_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等对方开始。取消静音即可听到他们。`)
};

const es_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperando a que empiece el otro participante. Activa el sonido para oírlo.`)
};

const pt_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguardando o outro participante começar. Ative o som para ouvir.`)
};

const id_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunggu orang lain mulai. Nyalakan suara untuk mendengar mereka.`)
};

const fr_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente de l’autre participant. Activez le son pour l’entendre.`)
};

const tl_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintaying magsimula ang kabilang tao. I-unmute para marinig sila.`)
};

const vi_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đợi người kia bắt đầu. Bật tiếng để nghe họ.`)
};

const ko_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상대방이 시작할 때까지 기다리세요. 소리를 들으려면 음소거를 해제하세요.`)
};

const de_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warte darauf, dass die andere Person startet. Schalte den Ton ein, um sie zu hören.`)
};

const ru_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дождитесь, пока второй участник начнёт. Включите звук, чтобы его слышать.`)
};

const tr_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer kişinin başlamasını bekleyin. Duymak için sesi açın.`)
};

const it_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspetta che l'altra persona inizi. Riattiva l'audio per sentirla.`)
};

const pl_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poczekaj, aż druga osoba zacznie. Wyłącz wyciszenie, aby ją słyszeć.`)
};

const uk_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зачекайте, поки друга людина почне. Увімкніть звук, щоб її чути.`)
};

const hi_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दूसरे व्यक्ति के शुरू करने की प्रतीक्षा करें। उन्हें सुनने के लिए ध्वनि चालू करें।`)
};

const ar_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتظر حتى يبدأ الشخص الآخر. ألغِ الكتم لتسمعه.`)
};

const ms_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunggu orang satu lagi bermula. Nyahsenyap untuk mendengar mereka.`)
};

const bn_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্য জনের শুরুর অপেক্ষা করুন। শুনতে শব্দ চালু করুন।`)
};

const zh_tw2_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等對方開始。取消靜音即可聽見他們。`)
};

const zh_hk2_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等對方開始。取消靜音即可聽見他們。`)
};

const ur_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوسرے شخص کے شروع کرنے کا انتظار کریں۔ سننے کے لیے آواز چالو کریں۔`)
};

const fa_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صبر کنید تا نفر دیگر آغاز کند. برای شنیدنش صدا را روشن کنید.`)
};

const sw_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiri mtu mwingine aanze. Washa sauti ili kumsikia.`)
};

const nl_meeting_test_peer_hint = /** @type {(inputs: Meeting_Test_Peer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wacht tot de ander begint. Zet het geluid aan om hem te horen.`)
};

/**
* | output |
* | --- |
* | "Waiting for the other participant to start. Enable sound to hear them." |
*
* @param {Meeting_Test_Peer_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_peer_hint = /** @type {((inputs?: Meeting_Test_Peer_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_Peer_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_peer_hint(inputs)
	if (locale === "ja") return ja_meeting_test_peer_hint(inputs)
	if (locale === "zh") return zh_meeting_test_peer_hint(inputs)
	if (locale === "es") return es_meeting_test_peer_hint(inputs)
	if (locale === "pt") return pt_meeting_test_peer_hint(inputs)
	if (locale === "id") return id_meeting_test_peer_hint(inputs)
	if (locale === "fr") return fr_meeting_test_peer_hint(inputs)
	if (locale === "tl") return tl_meeting_test_peer_hint(inputs)
	if (locale === "vi") return vi_meeting_test_peer_hint(inputs)
	if (locale === "ko") return ko_meeting_test_peer_hint(inputs)
	if (locale === "de") return de_meeting_test_peer_hint(inputs)
	if (locale === "ru") return ru_meeting_test_peer_hint(inputs)
	if (locale === "tr") return tr_meeting_test_peer_hint(inputs)
	if (locale === "it") return it_meeting_test_peer_hint(inputs)
	if (locale === "pl") return pl_meeting_test_peer_hint(inputs)
	if (locale === "uk") return uk_meeting_test_peer_hint(inputs)
	if (locale === "hi") return hi_meeting_test_peer_hint(inputs)
	if (locale === "ar") return ar_meeting_test_peer_hint(inputs)
	if (locale === "ms") return ms_meeting_test_peer_hint(inputs)
	if (locale === "bn") return bn_meeting_test_peer_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_peer_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_peer_hint(inputs)
	if (locale === "ur") return ur_meeting_test_peer_hint(inputs)
	if (locale === "fa") return fa_meeting_test_peer_hint(inputs)
	if (locale === "sw") return sw_meeting_test_peer_hint(inputs)
	if (locale === "nl") return nl_meeting_test_peer_hint(inputs)
	return en_meeting_test_peer_hint(inputs)
});